export enum ReducerKeys {
  PickingTask = 'pickingTask',
  Utility = 'utility',
  Dashboard = 'dashboard',
  ReplenishTask = 'replenishTask',
  PackingTask = 'packingTask',
  Company = 'company',
  StockTransfer = 'stockTransfer',
  InventoryAdjustment = 'inventoryAdjustment',
  STOPickItem = 'stoPickItem',
  STOCheckBasket = 'stoCheckBasket',
  STOReceiveItem = 'stoReceiveItem',
  InboundTaskDocument = 'inboundTaskDocument',
  InboundTaskItem = 'inboundTaskItem',
  InboundInvoice = 'inboundInvoice',
  DeliveryNote = 'deliveryNote',
}
